/* Modern light surfaces, layered over light.css: a soft gray canvas, white
   cards with hairline borders and gentle depth, and a violet accent. */
:root {
  --color-pageBackground: var(--palette-gray80);
  --color-pageTextPositive: var(--palette-purple600);
  --color-pageTextLink: var(--palette-purple600);

  --color-cardBackground: var(--palette-white);
  --color-cardBorder: var(--palette-border);

  --color-tableBackground: var(--palette-white);
  --color-tableHeaderBackground: var(--palette-gray50);
  --color-tableRowHeaderBackground: var(--palette-gray50);
  --color-tableRowBackgroundHover: var(--palette-gray80);
  --color-tableBorder: var(--palette-gray100);
  --color-tableRowBackgroundHighlight: var(--palette-purple100);

  --color-menuBorder: var(--palette-border);
  --color-modalBorder: var(--palette-border);
  --color-tooltipBorder: var(--palette-border);

  --color-buttonPrimaryBackground: var(--palette-purple500);
  --color-buttonPrimaryBackgroundHover: var(--palette-purple600);
  --color-buttonPrimaryShadow: rgba(80, 60, 200, 0.25);
  --color-buttonNormalBorder: var(--palette-gray150);
  --color-buttonNormalShadow: rgba(16, 18, 27, 0.06);

  --color-formInputBackground: var(--palette-white);
  --color-formInputBorder: var(--palette-gray150);
  --color-formInputBorderSelected: var(--palette-purple400);
  --color-formInputShadowSelected: var(--palette-purple150);

  --color-budgetOtherMonth: var(--palette-gray50);
  --color-budgetHeaderOtherMonth: var(--palette-gray80);

  --color-overlayBackground: rgba(16, 18, 27, 0.32);

  --shadow-sm: 0 1px 2px rgba(16, 18, 27, 0.05);
  --shadow-md:
    0 1px 2px rgba(16, 18, 27, 0.04), 0 4px 12px rgba(16, 18, 27, 0.06);
  --shadow-lg:
    0 4px 12px rgba(16, 18, 27, 0.06), 0 16px 40px rgba(16, 18, 27, 0.12);
  --focus-ring: 0 0 0 3px rgba(110, 85, 238, 0.18);
}
